import { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { resetIntercom } from '~/components/Intercom/resetIntercom';
import { UserContext } from '~/components/providers/UserProvider';
import { KYCContext } from '~/components/providers/KYCProvider';
import { clearAnalyticsUser, reportEvent } from '~/domains/analytics';
import Braze from '~/domains/analytics/braze/braze.class';
import { useClearDocumentsSubmitted } from '~/domains/market/domains/kyc/state/marketKycDocv.store';
import { usePlayerActivityStore } from '~/domains/market/domains/player-props/state/playerActivity.store';
import { logOut } from '~/services/identity/authenticated/identity.service.api';
import GeoComplySingleton from '~/utils/geocomply';

import { removeTokens } from '../utils/removeTokens';

const useLogout = () => {
  const { setUser } = useContext(UserContext);
  const { setKYCStatus } = useContext(KYCContext);
  const clearDocumentsSubmitted = useClearDocumentsSubmitted();
  const queryClient = useQueryClient();

  const { mutate: handleLogout, isLoading: isLoggingOut } = useMutation({
    mutationKey: ['logOut'],
    mutationFn: logOut,
    onSettled: () => {
      reportEvent('User > Logout');

      setUser(null);
      removeTokens();
      setKYCStatus(null);
      clearDocumentsSubmitted();
      usePlayerActivityStore.getState().reset();
      window.sessionStorage.setItem('sign_out', 'yes');
      queryClient.clear();
      GeoComplySingleton.invalidateToken();
      Braze.stop();
      resetIntercom();
      clearAnalyticsUser();
    },
  });

  return { handleLogout, isLoggingOut };
};

export default useLogout;
